module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: ["bg"],
    on: {
      "click": _vm.cancel
    }
  }, [_c('div', {
    ref: "boxWrap",
    staticClass: ["dof-confirm-box-wrap"],
    style: {
      height: _vm.wrapHeight,
      bottom: '0px'
    }
  }, [(_vm.title) ? _c('text', {
    staticClass: ["title"]
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('dof-image', {
    staticClass: ["closeIcon"],
    attrs: {
      "src": "../../assets/img/check/disuncheked.png",
      "width": "40px",
      "height": "40px"
    },
    on: {
      "click": _vm.cancel
    }
  }), _c('div', {
    staticClass: ["slot-floor"]
  }, [_vm._t("default")], 2), _c('div', {
    class: [_vm.isipx ? 'bottom-offset-padding' : '']
  })], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-58ad779b!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-confirm-box/index.vue
// module id = 611
// module chunks = 0 1